export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  // QM §5.7 — counterpart of WEBSOCKET_DISCONNECT, so push-driven screens can tell
  // the user their data went stale and refetch once the socket is back.
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  // QM §5.7 — a conversation changed server-side.
  CONVERSATION_UPDATED: 'CONVERSATION_UPDATED',
  SET_PLATFORM_ASSIGN_FILE: 'SET_PLATFORM_ASSIGN_FILE',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  CLOSE_REPLY: 'CLOSE_REPLY',
  TOGGLE_FORWARD_TO_MESSAGE: 'TOGGLE_FORWARD_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
};
